import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  viewChild,
} from '@angular/core';
import { EndOrderDetails } from '@pedix-workspace/utils';
import { hasAnyPriceModifier, getEndOrderToOrderTotalParams } from '@pedix-workspace/orders';
import { ModalDialogComponent } from '@pedix-workspace/angular-ui-modal';

import { OrderTotalDetailsComponent } from '../total-details/total-details.component';

import { CommonModule } from '@angular/common';
import { TranslocoDirective } from '@ngneat/transloco';
import {
  IconCheckoutComponent,
  IconClockComponent,
  IconFormComponent,
  IconPaymentComponent,
  IconPriceDiscountComponent,
  IconShippingComponent,
  IconUsersComponent,
} from '@pedix-workspace/angular-ui-icons';
import { CurrencyFormatPipe } from '@pedix-workspace/pedixapp-shared-pipes';
import { AlertComponent } from '@pedix-workspace/angular-ui-alert';
import { format } from 'date-fns';
import { CartItemsListComponent } from '../cart-items-list/cart-items-list.component';
import { ResumeItemComponent } from '@pedix-workspace/pedixapp-shared-catalog';
import { OrderDetailsCustomerComponent } from './order-details-customer/order-details-customer.component';
import { OrderDetailsShippingOptionComponent } from './order-details-shipping-option/order-details-shipping-option.component';
import { OrderDetailsPaymentMethodComponent } from './order-details-payment-method/order-details-payment-method.component';
import { OrderDetailsCustomFieldsComponent } from './order-details-custom-fields/order-details-custom-fields.component';
import { OrderDetailsSectionComponent } from './order-details-section/order-details-section.component';
import { OrderDetailsBillingComponent } from './order-details-billing/order-details-billing.component';

@Component({
  selector: 'pxw-order-details',
  templateUrl: './order-details.component.html',
  styleUrls: ['./order-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    TranslocoDirective,
    OrderTotalDetailsComponent,
    IconClockComponent,
    IconPaymentComponent,
    IconShippingComponent,
    IconFormComponent,
    CurrencyFormatPipe,
    AlertComponent,
    ModalDialogComponent,
    CartItemsListComponent,
    ResumeItemComponent,
    CommonModule,
    IconUsersComponent,
    IconPriceDiscountComponent,
    IconCheckoutComponent,
    AlertComponent,
    OrderDetailsCustomerComponent,
    OrderDetailsShippingOptionComponent,
    OrderDetailsPaymentMethodComponent,
    OrderDetailsCustomFieldsComponent,
    OrderDetailsSectionComponent,
    OrderDetailsBillingComponent,
  ],
})
export class OrderDetailsComponent {
  readonly totalDetailsDialog = viewChild.required<ModalDialogComponent>('totalDetailsDialog');

  readonly orderDetails = input.required<EndOrderDetails>();
  readonly displayShippingEstimate = input(false);
  readonly displaySku = input(false);
  readonly editEnabled = input(false);
  readonly adminMode = input(false);
  readonly whatsappButtonEnabled = input(false);
  readonly isShippingRequestInProgress = input(false);
  readonly displayBillingInformation = input<boolean>(false);

  readonly cancelShipping = output();
  readonly confirmShipping = output();
  readonly createShipping = output();
  readonly editCustomerData = output();
  readonly editShippingOption = output();
  readonly editPaymentMethod = output();
  readonly editCustomFields = output();
  readonly editBillingInformation = output();
  readonly editCoupon = output();
  readonly editCart = output();

  readonly formattedDate = computed(
    () => format(this.orderDetails().created, 'dd MMMM yyyy - hh:mm') + 'hs',
  );
  readonly displayTotalDetails = computed((): boolean => {
    const details = this.orderDetails();

    return hasAnyPriceModifier(getEndOrderToOrderTotalParams(details));
  });
  readonly orderWasShipped = computed((): boolean => {
    const shippingOrder = this.orderDetails().shippingOrder;

    if (!shippingOrder) {
      return false;
    }
    return shippingOrder.status !== 'CANCELLED';
  });

  showTotalDetails() {
    this.totalDetailsDialog().open().catch();
  }
}
